import { render, staticRenderFns } from "./SmartAgent.vue?vue&type=template&id=18a4df0b&scoped=true"
import script from "./SmartAgent.vue?vue&type=script&lang=js"
export * from "./SmartAgent.vue?vue&type=script&lang=js"
import style0 from "./SmartAgent.vue?vue&type=style&index=0&id=18a4df0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a4df0b",
  null
  
)

export default component.exports